// extracted by mini-css-extract-plugin
module.exports = {"consultIcon":"ButtonConsult_consultIcon__uFw3W","button":"ButtonConsult_button__lAQMX"};